import { IonItem, IonLabel, IonList } from '@ionic/react'

import { useGroupMemberPosId } from '../queries'

type Props = {
  id: string
  onClick: ({ posId }: { posId: string }) => void
}

function AddGroupMemberPosIds({ id, onClick }: Props) {
  const groupMemberPosIds = useGroupMemberPosId({ id })

  return (
    <IonList color="secondary">
      {groupMemberPosIds.data?.length === 0 && (
        <IonItem color="secondary">
          <IonLabel>No POS IDs found</IonLabel>
        </IonItem>
      )}
      {groupMemberPosIds.data?.map((r) => (
        <IonItem
          color="secondary"
          key={r.posId}
          onClick={() => onClick({ posId: r.posId || '' })}
        >
          <IonLabel>{r.posId}</IonLabel>
        </IonItem>
      ))}
    </IonList>
  )
}

export { AddGroupMemberPosIds }
